import React from 'react';
import { IconProps } from '@icons/types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '@icons/utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const ResizerIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg width={svgWidth} height={svgHeight} viewBox="0 0 8 8" fill="none" {...restProps}>
            <path
                fillRule="evenodd"
                d="M1.422 8h5.17C7.373 8 8 7.37 8 6.591V1.415C8 .157 6.473-.473 5.584.416L.414 5.592C-.476 6.482.163 8 1.421 8z"
                clipRule="evenodd"
                fill={color}
            ></path>
        </svg>
    );
};

export default React.memo(ResizerIcon);
